/**
 * sl-728o.7.3: Presentation Tutorial Session
 *
 * 3 steps guiding the user through presentation mode.
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';
import { ensureEdgelessMode } from './targets';

type I18n = ReturnType<typeof useI18n>;

export function createPresentationSession(t: I18n): TutorialSession {
  return {
    id: 'tutorial:presentation',
    context: {
      targetAudience: 'all',
      category: 'basics',
    },
    steps: [
      {
        targetSelector: '.affine-edgeless-viewport',
        title:
          t['com.streamlain.streamlain.tutorial.presentation.step1.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.presentation.step1.content'](),
        animation: 'none',
        onEnter: ensureEdgelessMode,
        delay: 650,
        trigger: { type: 'manual' },
        position: 'auto',
      },
      {
        targetSelector: '[data-testid="detail-header-present-button"]',
        title:
          t['com.streamlain.streamlain.tutorial.presentation.step2.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.presentation.step2.content'](),
        animation: 'pulse',
        trigger: { type: 'manual' },
        position: 'bottom',
      },
      {
        targetSelector: '.affine-edgeless-viewport',
        title:
          t['com.streamlain.streamlain.tutorial.presentation.step3.title'](),
        content:
          t['com.streamlain.streamlain.tutorial.presentation.step3.content'](),
        animation: 'none',
        trigger: { type: 'manual' },
        position: 'auto',
      },
    ],
  };
}
